// libs
import { styled } from '@nykaa/ui-components';

// components
import ModalBase from 'shared/components/Modal';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const iFrameStyles = `
    html {
        margin: 0; padding: 0;
    }

    body, .mobileSizeChart {
        float: none;
        width: 100%;
    }

    ::-webkit-scrollbar
    {
        width: 3px;
        height: 4px;
        margin-top: 10px;
        background-color: #9b9b9b;
        border: 1px solid white;
    }
    ::-webkit-scrollbar-thumb
    {
        width: 3px;
        background-color: #000000;
        border-radius: 10px;
    }

    .sizeGuideWrap .sizeGuideContainer{
        margin: 0;
        box-shadow: none;
    }

    @media (max-width: 1112px){
        .sizeGuideWrap{
            padding: 0 15px;
        }
    }
`; //leaving here

export const innerClassName = 'size-chart-modal';
export const Modal = styled(ModalBase)`
  overflow: hidden;
  padding: ${({ theme }) => `${theme.spacing.spacing200} 0`};

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    max-width: 100vw;
    max-height: 100vh;
  }

  //edge case for ios devices for handing dynamic w
  @supports (-webkit-touch-callout: none) {
    padding-top: ${({ theme }) => theme.spacing.spacing240};
    button:first-of-type {
      top: 50px;
    }
  }

  .${innerClassName} {
    min-height: 500px;
    padding: ${({ theme }) => `${theme.spacing.spacing100} ${theme.spacing.spacing200}`};
    background: #fff;
    width: 650px;

    @media (max-width: ${BREAKPOINTS.MOBILE}px) {
      min-height: 100vh;
      padding: 0;
    }
  }
`;

export const Iframe = styled.iframe`
  border: 0;
  min-height: 460px;
  min-width: 550px;

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    min-height: 90vh;
    min-width: 100vw;
  }
`;
